import api from '@/api'

export default {
  /**
   * 대용량 첨부 템플릿을 가져옵니다.
   * @param {string} code 대용량 첨부 그룹 코드
   * @returns template html string
   */
  deleteFiles: function(code: string, codeValues: string[], fileNames: string[]): Promise<string> {
    return api.post({
      url: '/file/store/api/delete',
      data: { code, codeValues, fileNames },
    })
  },
}
